import { useLocalStorage } from '@vueuse/core';

type IdpData = {
  domain?: string;
  projectId?: string;
  successRedirect: string;
  failureRedirect: string;
}

export const useIdpLogin = () => {
  const idpData = useLocalStorage<IdpData>('idp-login', {
    domain: '',
    projectId: '',
    successRedirect: '',
    failureRedirect: ''
  });

  return {
    save: (data: IdpData) => {
      idpData.value.domain = data.domain;
      idpData.value.projectId = data.projectId;
      idpData.value.successRedirect = data.successRedirect;
      idpData.value.failureRedirect = data.failureRedirect;
    },
    get: (key: keyof IdpData) => idpData.value[key],
  };
};

export default useIdpLogin;
